import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
}), 'ShowChart');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ShowChart.js
// module id = 6118
// module chunks = 2